export default __webpack_public_path__ + "static/media/Sugercane.f9b3b5cc.jpg";